import type { DocMigration } from "../docMigration";

const docEntityTypeToDocTableName = {
  GROUP: "groups",
  COMPONENT: "components",
  COMPONENT_INSTANCE: "componentInstances",
  DOC_REF: "docRefs",
  BUILDER_REF: "builderRefs",
  LEVEL: "levels",
  BLOCK: "blocks",
  ROOM: "rooms",
  STAIR_SYSTEM: "stairSystems",
  STAIR_BLOCK: "stairBlocks",
  RAILING: "railings",
  PRESET: "presets",
  ROOF_SYSTEM: "roofSystems",
  ROOF: "roofs",
  ROOF_VOLUME: "roofVolumes",
  FOUNDATION_SYSTEM: "foundationSystems",
  FOUNDATION: "foundations",
  UNDERLAY: "underlays",
  ASSET: "assets",
  REFERENCE_GEOM: "referenceGeom",
  ELEVATION: "elevations",
  PALETTE: "palettes",
  SETTINGS: "settings",
  SETTINGS_SET: "settingsSets",
  ENTITY_SETTINGS: "entitySettings",
  OPTION_TEMPLATE: "optionTemplates",
  SHEET: "sheets",
  DRAWING_REF: "drawingRefs",
  OPTION_SET_OVERRIDES: "optionSetOverrides",
  OPTION_SET: "optionSets",
  OPTION_RULE: "optionRules",
  OPTION_EFFECT: "optionEffects",
  OPTION_LOCK: "optionLocks",
  PROP_INSTANCE: "propInstances",
  PROP: "propAttributes",
  PROP_DEF: "propDefs",
  CASEWORK: "casework",
  CEILING: "ceilings",
  EDGE_BEHAVIOR: "edgeBehaviors",
  OPENING: "openings",
  ANNOTATION: "annotation",
  FACADE: "facades",
  DORMER: "dormers",
  SITE: "sites",
  SITE_SHAPE: "siteShapes",
  MODIFIER: "modifiers",
  MEASUREMENT: "measurements",
  VIEW_3D: "view3Ds",
  ELEVATION_VIEW: "elevationViews",
  PLAN_VIEW: "planViews",
  OPTION_SET_REF: "optionSetRefs",
  ROOM_LAYOUT: "roomLayouts",
  ROOM_LAYOUT_INSTANCE: "roomLayoutInstances",
  SKYLIGHT: "skylights",
  ROOF_OPENING: "roofOpenings",
  COLUMN: "columns",
  FLOOR: "floors",
  FLOOR_FINISH: "floorFinishes",
  FACADE_SPAN_STRATUM: "facadeSpanStrata",
  FACADE_SWEEP_STRATUM: "facadeSweepStrata",
  RAILING_POST: "railingPosts",
  EDGE_MODIFIER: "edgeModifiers",
  ELECTRICAL_DEVICE: "electricalDevices",
  ELECTRICAL_LAYOUT: "electricalLayouts",
  PLAN_SET_TEMPLATE: "planSetTemplates",
  CONTENT_TEMPLATE: "contentTemplates",
  CONTENT_TEMPLATE_INSTANCE: "contentTemplateInstances",
  CONTENT_REPLICATOR: "contentReplicators",
  LOCAL_PARAMETER: "localParameters",
  GLOBAL_PARAMETER: "globalParameters",
  SYSTEM_PARAMETER: undefined,
  VIEWPORT: "viewports",
  VIEW_TEMPLATE: "viewTemplates",
  VIEW_TEMPLATE_OVERRIDE: "viewTemplateOverrides",
  DATA_TABLE: "dataTables",
  DATA_SEQUENCE: "dataSequences",
  SECTION_VIEW: "sectionViews",
  SELECTOR: "selectors",
  VIEW_OVERRIDE: "viewOverrides",
  VIEW_SELECTOR: "viewSelectors",
  PLAN_SET_TEMPLATE_CONFIG: "planSetTemplateConfigs",
  AUTO_DIMENSION: undefined,
  ENTITY_TAG: "entityTags",
  EFFECT: "effects",
  DATUM: "datums",
  RULE_BASED_SELECTOR: "ruleBasedSelectors",
  RULE_BASED_SELECTOR_INSTANCE: "ruleBasedSelectorInstances",
  ROOF_SIDE: undefined,
  OPTION: undefined,
  CATALOG_ITEM: undefined,
  ANNOTATION_TEMPLATE: undefined,
  ANNOTATION_TEMPLATE_COMPONENT: undefined,
  ELECTRICAL_RULE: undefined,
  SHAPE: undefined,
  EDGE: undefined,
  VERTEX: undefined,
  EDIT_MODE: undefined,
  GENERATED_ENTITY: undefined,
  INDETERMINATE_ENTITY_TYPE: undefined,
  FRAMING_COMPONENT: "framingComponents",
  FOUNDATION_ASSEMBLY: "foundationAssemblies",
  FOUNDATION_COMPONENT: "foundationComponents",
  HEADER_ASSEMBLY: "headerAssemblies",
  FRAME_FLOOR_ASSEMBLY: "frameFloorAssemblies",
  SLAB_FLOOR_ASSEMBLY: "slabFloorAssemblies",
  SLAB_COMPONENT: "slabComponents",
  SHEATHING_COMPONENT: "sheathingComponents",
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_506: DocMigration = {
  maxSchemaVersion: "0.0.506",
  description: "Remove orphaned entity refs from the doc",
  apply(json: any): any {
    if (!Object.keys(json.entityRefs).length) {
      return json;
    }

    if (!Object.keys(json.docRefs).length) {
      json.entityRefs = {};
      return json;
    }

    const orphanedEntityRefs: Record<string, { entityType: string }> = {};

    for (const id in json.entityRefs) {
      const entityRef = json.entityRefs[id];

      const docTableName = docEntityTypeToDocTableName[entityRef.entityType];

      if (!docTableName) {
        continue;
      }

      if (!json[docTableName][entityRef.id]) {
        orphanedEntityRefs[id] = entityRef;
        delete json.entityRefs[id];
        continue;
      }
    }

    console.warn(`Deleted ${Object.keys(orphanedEntityRefs).length} orphaned entity refs`);

    return json;
  },
};

export default migration_0_0_506;
